<template>
  <div class="card economicsTypeBlock">
    <SectionTitle :text="title" />
    <ul class="card__list indicators__list">
      <li v-for="item in indicators" :key="item.id" class="card__item indicators__itemCustom">
        <p class="text-align-left fs14 fw600 mb-6 indicators__itemTitle">{{ item.title }}</p>
        <slot name="item" :item="item" />
      </li>
    </ul>
  </div>
</template>

<script>
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';

  export default {
    name: 'EconomicsReviewCard',
    components: { SectionTitle },
    props: {
      title: {
        type: String,
        required: true,
      },
      indicators: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  .indicators__itemTitle {
    white-space: pre-line;
  }

  .card {
    &__list {
      display: flex;
      flex-wrap: wrap;
      gap: 36px 16px;

      @media (max-width: 1150px) {
        gap: 36px;
        justify-content: center !important;
      }
      @media (max-width: $tablet) {
        justify-content: space-between !important;
      }
    }

    &__item {
      min-width: 150px;
      max-width: 370px;
      width: 100%;

      @media (max-width: $tablet) {
        max-width: 320px !important;
      }
    }
  }
</style>
